import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
import breakdownImage from '../images/chonky-breakdown.jpg';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "component-hierarchy"
    }}>{`Component hierarchy`}</h1>
    <p>{`You already saw the `}<inlineCode parentName="p">{`FullFileBrowser`}</inlineCode>{` component on the `}<a parentName="p" {...{
        "href": "/docs/2.x/installation-usage"
      }}><em parentName="a">{`Installation &
usage`}</em></a>{` page:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { FullFileBrowser } from 'chonky';

export const MyFileBrowser = () => {
    const files = [];
    return <FullFileBrowser files={files} />;
};
`}</code></pre>
    <p><inlineCode parentName="p">{`FullFileBrowser`}</inlineCode>{` is actually just a convenient shorthand to the code shown below. It is
a good idea to use `}<inlineCode parentName="p">{`FullFileBrowser`}</inlineCode>{` if you want all Chonky's features. Plus, using it
means new components Chonky introduces will be automatically enabled in your app!`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import {
    FileBrowser,
    FileContextMenu,
    FileList,
    FileNavbar,
    FileToolbar,
} from 'chonky';

export const MyFileBrowser = () => {
    const files = [];
    return (
        <FileBrowser files={files}>
            <FileNavbar />
            <FileToolbar />
            <FileList />
            <FileContextMenu />
        </FileBrowser>
    );
};
`}</code></pre>
    <br />
    <p>{`However, there are situations where you might want to disable some Chonky components,
e.g. if you want to provide your own context menu.`}</p>
    <p>{`The only required component is `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{`, which should appear on top level. All
other components are optional - for example, if you just want to show a list of files,
without toolbars or navigation, you would use:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<FileBrowser files={[]}>
    <FileList />
</FileBrowser>
`}</code></pre>
    <p>{`Power users might also want to provide their own implementations of different
components. For example, someone could make a custom `}<inlineCode parentName="p">{`MyToolbar`}</inlineCode>{` component by cloning
Chonky's `}<inlineCode parentName="p">{`FileToolbar`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<FileBrowser files={[]}>
    <MyToolbar />
    <FileList />
</FileBrowser>
`}</code></pre>
    <h2 {...{
      "id": "component-breakdown"
    }}>{`Component breakdown`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`FileBrowser`}</inlineCode>{` - the top level component. It provides several React contexts for
its children, including Redux store and JSS theme.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`FileNavbar`}</inlineCode>{` - navigation component. It shows the path to the current folder.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`FileToolbar`}</inlineCode>{` - main controls component. It contains a search bar and file action
buttons.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`FileList`}</inlineCode>{` - file list component (duh). It shows files to users and lets them
make selection or drag & drop things.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`FileContextMenu`}</inlineCode>{` - menu component. It provides the right-click menu with file
actions.`}</li>
    </ul>
    <img src={breakdownImage} alt="Chonky component hierarchy" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      